import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import { StyledInputLabel } from "./styles";

const MuiSelect = React.forwardRef((props: any, ref: any) => {
  const { label, name, options, required, errorobj } = props;
  let isError = false;
  let errorMessage = "";
  if (errorobj && errorobj.hasOwnProperty(name)) {
    isError = true;
    errorMessage = errorobj[name].message;
  }
  return (
    <FormControl fullWidth error={isError} variant="standard">
      <StyledInputLabel id={name}>
        {label} {required ? <span className="req-label">*</span> : null}
      </StyledInputLabel>
      <Select labelId={name} id={name} {...props}>
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        {options.map((item: any) => (
          <MenuItem key={item.id} value={item.id}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText>{errorMessage}</FormHelperText>
    </FormControl>
  );
});

function FormSelect(props: any) {
  const { control } = useFormContext();
  const { name, required } = props;
  return (
    <React.Fragment>
      <Controller
        render={({ field }) => <MuiSelect {...field} {...props} />}
        name={name}
        control={control}
        rules={{ required: required || false }}
        defaultValue=""
      />
    </React.Fragment>
  );
}

export default FormSelect;
